export const reassignAndTerminateRequestList_actionType = {
    REASSIGN_AND_TERMINATE_REQUEST_LIST: "REASSIGN_AND_TERMINATE_REQUEST_LIST",
    REASSIGN_AND_TERMINATE_REQUEST_LIST_SUCCESS: "REASSIGN_AND_TERMINATE_REQUEST_LIST_SUCCESS",
    REASSIGN_AND_TERMINATE_REQUEST_LIST_ERROR: "REASSIGN_AND_TERMINATE_REQUEST_LIST_ERROR",
    REASSIGN_AND_TERMINATE_REQUEST_LIST_SELECT_REQUEST: "REASSIGN_AND_TERMINATE_REQUEST_LIST_SELECT_REQUEST",
    SET_REASSIGN_AND_TERMINATE_FILTER_DATA: 'SET_REASSIGN_AND_TERMINATE_FILTER_DATA'
};